<template>
  <div id="zuhauseStatus">
    <div v-if="benutzer.istZuhause" class="main-icon-box bg-info text-white" @click="changeStatus()">
      <font-awesome-icon icon="home" class="icon-size"/>
      <h3><strong>Ich bin zuhause</strong></h3>
    </div>
    <div v-else class="main-icon-box bg-dark text-white" @click="changeStatus()">
      <font-awesome-icon icon="shoe-prints" class="icon-size"/>
      <h3><strong>Ich bin unterwegs</strong></h3>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
export default {
  name: 'ZuhauseStatus',
  computed: mapGetters(['benutzer', 'benutzerStatus']),
  methods: {
    ...mapActions(['changeZuhauseStatus', 'favoritenEmailSenden']),
    changeStatus () {
      this.changeZuhauseStatus()
        .then(() => {
          if (!this.benutzerStatus.errMsg) {
            const message = {}
            if (!this.benutzer.istZuhause) {
              message.subject = `${this.benutzer.vorname} ${this.benutzer.name} ist unterwegs`
            } else {
              message.subject = `${this.benutzer.vorname} ${this.benutzer.name} ist anwesend`
            }

            message.message = `Telefon: ${this.benutzer.tel} \nMobil: ${this.benutzer.mobil} \n\n${this.benutzer.strasse}\n${this.benutzer.plz} ${this.benutzer.ort}\n${this.benutzer.land}`

            this.favoritenEmailSenden(message)
          } else {
            const toastData = {
              title: "Keine Verbingung zum Senio Server",
              msg: "Die Nachricht konnte nicht gesendet werden",
              variant: "danger"
            };

            this.$emit("errorMsg", toastData);
          }
        })
    }
  },
  data () {
    return {
      zuhause: true
    }

  }
}
</script>

<style scoped>
  .main-icon-box {
    padding-top: 2em;
    width: 400px;
    height: 200px;
    margin: auto;
    border-radius: 50%;
    box-shadow: 0px 0px 5px #1a1a1a;
    transition: all .2s ease-in-out;
  }

  .main-icon-box:hover {
    transform: scale(1.1);
  }

  .main-icon-box:hover {
    cursor:   pointer 
  }

  .icon-size {
    font-size: 5em;
  }

  
@media screen and (max-width: 576px) {
    .main-icon-box {
      width: 160px;
      height: 160px;
      padding-top: 1.4em;
    }

    .icon-size{
      font-size: 3em;
    }

    h3 {
      font-size: 1.5rem;
    }
  }

@media screen and (min-width: 577px) and (max-width: 992px) {
  .main-icon-box {
      width: 190px;
      height: 190px;
      padding-top: 1.8em;
    }

    .icon-size{
      font-size: 4em;
    }
}
</style>
